import { SxProps } from '@mui/system';

export const accordianSummaryCSS: SxProps = {
  maxHeight: '400px',
  height: 'auto',
  overflow: 'hidden',
  overflowY: 'scroll',
};

export const summaryGridClass: SxProps = {
  background: '#fff',
  borderRadius: '12px',
  border: '1px solid rgba(17, 25, 39, 0.16)',
  color: '#384250',
  cursor: 'pointer',
  position: 'relative',
  '&:hover': {
    background: 'rgb(177, 171, 179)',
    color: '#FFF',
  },
};

export const summyDescription: SxProps = {
  position: 'absolute',
  left: '50%',
  top: '50%',
  WebkitTransform: 'translate(-50%, -50%)',
  transform: 'translate(-50%, -50%)',
  color: '#000000',
};
